import getXHR, { XhrResponse } from 'Partials/xhr';
import { PricingFrequency } from '../modalUpgrade';

export class Subscription {
    public static upgrade(options: SubscriptionUpgradeOptions): Promise<XhrResponse> {
        const data = new FormData();
        Object.keys(options).forEach(key => data.append(key, options[key]));

        return getXHR(`${BASE_URL}ajax/pricing/add-product`, {
            data,
            method: 'POST',
            withCredentials: true,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
    }
}

interface SubscriptionUpgradeOptions {
    coupon?: string;
    frequency: PricingFrequency;
    [key: string]: any;
}
